'use client'

import { useState } from 'react'
import { MessageCircle, X } from 'lucide-react'
import { useCompanyInfo } from '@/contexts/CompanyInfoContext'

export default function FloatingWhatsApp() {
  const { companyInfo } = useCompanyInfo()
  const [isVisible, setIsVisible] = useState(true)
  const [showTooltip, setShowTooltip] = useState(false)

  // Only show if WhatsApp number is configured
  const whatsappNumber = companyInfo?.contact?.whatsapp
  if (!whatsappNumber) {
    return null
  }

  const formatWhatsAppNumber = (number: string) => {
    const cleaned = number.replace(/[^\d+]/g, '')
    if (!cleaned.startsWith('+')) {
      return `+91${cleaned}`
    }
    return cleaned
  }

  const openWhatsApp = () => {
    const formattedNumber = formatWhatsAppNumber(whatsappNumber)
    const message = encodeURIComponent("Hi! I'm interested in your services. Can we discuss?")
    const whatsappUrl = `https://wa.me/${formattedNumber.replace('+', '')}?text=${message}`
    window.open(whatsappUrl, '_blank')
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-6 right-6 z-[9999]">
      <div className="relative">
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute right-16 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap shadow-lg">
            Need help? Chat with us!
            <div className="absolute top-1/2 transform -translate-y-1/2 -right-1 w-2 h-2 bg-gray-800 rotate-45"></div>
          </div>
        )}

        {/* WhatsApp Button */}
        <button
          onClick={openWhatsApp}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="group relative w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center hover:scale-110"
        >
          {/* Pulse animation */}
          <div className="absolute inset-0 bg-green-500 rounded-full animate-pulse opacity-70"></div>
          
          <MessageCircle className="w-7 h-7 text-white relative z-10" />
          
          {/* Badge/notification dot */}
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-pulse"></div>
        </button>

        {/* Close button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute -top-2 -left-2 w-6 h-6 bg-gray-600 hover:bg-gray-700 rounded-full shadow-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          <X className="w-3 h-3 text-white" />
        </button>
      </div>
    </div>
  )
}